const baseUrl = process.env.VUE_APP_BASEURL
const baseUrlSocket = process.env.VUE_APP_BASEURLSOCKET
const domain = process.env.VUE_APP_DOMAIN
const backstageDomain = process.env.VUE_APP_BACKSTAGEDOMAIN
const sentryRelease = process.env.VUE_APP_GIT_COMMIT
const sentry = process.env.VUE_APP_SENTRY
const env = process.env.VUE_APP_ENVAPP
const workerUrl = process.env.VUE_APP_BASEWORKERTURL
const presenterDomain = process.env.VUE_APP_PRESENTERDOMAIN
const audienceLink = process.env.VUE_APP_AUDIENCEDOMAIN
const stripePublicKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY
const sentryEnabled = process.env.VUE_APP_SENTRY_ENABLED === 'true'
const singaporeStripePublishableKey = process.env.VUE_APP_SINGAPORE_STRIPE_PUBLISHABLE_KEY
const MAX_NUMBER_OF_SLIDE = process.env.VUE_APP_MAX_NUMBER_OF_SLIDE || 500
const MAX_FOLDER_DEPTH = process.env.VUE_APP_MAX_FOLDER_DEPTH || 10
const MAX_PRESENTATION_IN_FOLDER = process.env.VUE_APP_MAX_PRESENTATION_IN_FOLDER || 10
const keyRecapcha = process.env.VUE_APP_KEYRECAPTCHA
const mceEditorKey = process.env.VUE_APP_MCE_EDITOR
const accountRemovalURL = env === 'production' ? 'https://ahaslides.com/' : `${presenterDomain}/`
const region = process.env.VUE_APP_REGION || 'gb'
const paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID
const configFile = `${process.env.VUE_APP_CLOUD_FRONT_PUBLIC_URL}/configurations/${env === 'production' ? 'config' : 'config-dev'}.json`
const enableZoho = process.env.VUE_APP_ZOHO_ENABLE
  && process.env.VUE_APP_ZOHO_ENABLE === 'true'
const ssrDomain = process.env.VUE_APP_SSR_DOMAIN
const openTokKey = process.env.VUE_APP_OPENTOK_KEY
const powerpointDomain = process.env.VUE_APP_POWERPOINT_URL
const ga4Id = process.env.VUE_APP_GA4_ID
const cloudfrontPublic = process.env.VUE_APP_CLOUD_FRONT_PUBLIC_URL
const oneSignalAppId = process.env.VUE_APP_ONESINGAL_APP_ID
const youtubeAPIKey = process.env.VUE_APP_YOUTUBE_API_KEY
window.enableMixpanel = function () {
  localStorage.setItem('mt-enabled', 'true')
}

window.PRESENTER_APP_VERSION = '1.0.0'

export default {
  baseUrl,
  baseUrlSocket,
  domain,
  backstageDomain,
  sentry,
  sentryEnabled,
  sentryRelease,
  env,
  baseSupportUrl: workerUrl,
  presenterDomain,
  audienceDomain: env === 'local' ? `http://${audienceLink}` : `https://${audienceLink}`,
  audienceHttpsEndpoint: `https://${audienceLink}`,
  audienceLink,
  skoletubeHomepage: 'https://www.skoletube.dk/',
  accountRemovalURL: `${accountRemovalURL}?utm_source=presenter_app&utm_medium=presenter_app&utm_campaign=account_deletion_completed`,
  keyRecapcha,
  mceEditorKey,
  region,
  paypalClientId,
  enableZoho,
  ssrDomain,
  openTokKey,
  powerpointDomain,
  cloudfrontPublic,
  oneSignalAppId,
  youtubeAPIKey,
  mixpanel: {
    projectToken: process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN,
    proxyUrl: process.env.VUE_APP_MIXPANEL_PROXY_URL,
  },
  api: {
    createAccount: `${baseUrl}/api/users/create-presenter/`,
    createSkoletubePresenter: `${baseUrl}/api/users/create-skoletube-presenter/`,
    updateUserSettings: `${baseUrl}/api/users/update-settings`,
    login: `${baseUrl}/api/auth/presenter/`,
    account: `${baseUrl}/api/users/account/`,
    resetPassword: `${baseUrl}/api/reset-password/email/`,
    confirmPassword: `${baseUrl}/api/reset-password/confirm/`,
    createPresentation: `${baseUrl}/api/presentation/create/`,
    getPresentationDetail: `${baseUrl}/api/presentation/detail/`,
    getPresentationBasic: `${baseUrl}/api/presentation/basic/`,
    updatePresentation: `${baseUrl}/api/presentation/update/`,
    sortSlide: `${baseUrl}/api/slide/sort-slide/`,
    getSlides: `${baseUrl}/api/slide/list/`,
    getCategories: `${baseUrl}/api/presentation/categories/for-presentations/`,
    getCategoryDetail: `${baseUrl}/api/presentation/categories/detail-for-presenter/`,
    duplicateSlideToOtherPresentation: `${baseUrl}/api/slide/duplicate-other-presentation/`,
    updateSlide: `${baseUrl}/api/slide/update/`,
    createSlide: `${baseUrl}/api/slide/create/`,
    duplicateSlide: `${baseUrl}/api/slide/duplicate/`,
    createSlideOption: `${baseUrl}/api/slide-option/create/`,
    updateSlideOption: `${baseUrl}/api/slide-option/update/`,
    updateEventSlideOption: `${baseUrl}/api/slide-option/update-event/`,
    removeWordCloud: `${baseUrl}/api/slide-option/remove-wordcloud/`,
    uploadSlideOptionImage: `${baseUrl}/api/slide-option/slide-option-image/`,
    updateStatusResult: `${baseUrl}/api/presentation/status-result/`,
    changeAccessCode: `${baseUrl}/api/presentation/change-access-code/`,
    uploadSlideImage: `${baseUrl}/api/slide/slide-image/`,
    resizeImage: `${baseUrl}/api/upload/resize/`,
    resizeCustomThumbnailImage: `${baseUrl}/api/upload/resize-custom-thumbnail/`,
    uploadPresentationLogo: `${baseUrl}/api/presentation/upload-logo/`,
    applyBackgroundConfigSlide: `${baseUrl}/api/slide/slide-apply-background/`,
    duplicatePresentation: `${baseUrl}/api/presentation/duplicate/`,
    sharePresentation: `${baseUrl}/api/presentation/share-presentation/`,
    copyPresentation: `${baseUrl}/api/presentation/copy-presentation/`,
    getAudienceOnline: `${baseUrl}/api/presentation/count-audience/`,
    getResultLeaderboard: `${baseUrl}/api/slide/slide-leaderboard/`,
    getDetailPricing: `${baseUrl}/api/pricing/plan-detail/`,
    getIdealPaymentMethod: `${baseUrl}/api/pricing/payment-method-ideal/`,
    idealCheckout: `${baseUrl}/api/pricing/create-session-checkout-ideal/`,
    checkInvoicePaid: `${baseUrl}/api/pricing/check-invoice-paid/`,
    checkout: `${baseUrl}/api/pricing/checkout/`,
    checkoutUpgradePlan: `${baseUrl}/api/pricing/upgrade/`,
    myPlan: `${baseUrl}/api/pricing/my-plan/`,
    paymentHookSlack: `${baseUrl}/api/pricing/hook-slack/`,
    getInvoiceIdBySessionId: `${baseUrl}/api/pricing/get-invoice-by-session-id/`,
    getCustomerStripeForMethodCard: `${baseUrl}/api/pricing/get-customer-stripe-for-card/`,
    clearAudienceData: `${baseUrl}/api/presentation/clear-data-audience/`,
    uploadImage: `${baseUrl}/api/upload/image/`,
    uploadXlsx: `${workerUrl}/api/upload/xlsx/`,
    publicUpload: `${baseUrl}/api/upload/public-upload`,
    uploadLink: `${baseUrl}/api/upload/link/`,
    getQuestion: `${baseUrl}/api/question/list/`,
    updateQuestion: `${baseUrl}/api/question/update/`,
    clearDataSlide: `${baseUrl}/api/slide/clear-data/`,
    confirmCheckout: `${baseUrl}/api/pricing/confirm-checkout/`,
    importDocument: `${baseUrl}/api/presentation/import-document/`,
    changeSubscription: `${baseUrl}/api/pricing/change-status-subscription/`,
    quizHook: `${baseUrl}/api/hook/quiz/`,
    createLeaderboard: `${baseUrl}/api/slide/presenter-create-leaderboard/`,
    updateNextSlide: `${baseUrl}/api/presentation/update-next-slide/`,
    collabNextSlide: `${baseUrl}/api/collab/next-slide/`,
    getDataQuizTypeAnswer: `${baseUrl}/api/answer/quiz-type-answer/`,
    searchUnsplash: `${baseUrl}/api/slide/search-unsplash`,
    searchGiphy: `${baseUrl}/api/slide/search-giphy`,
    checkQuizTeamMember: `${baseUrl}/api/quiz/set-team-data/`,
    invoice: `${baseUrl}/api/invoice/`,
    removeCards: `${baseUrl}/api/pricing/remove-card/`,
    updateCard: `${baseUrl}/api/pricing/update-card/`,
    slideScaleQuestion: `${baseUrl}/api/slide/scale-result/`,
    removeUserAccount: `${baseUrl}/api/users/`,
    getInvitation: `${baseUrl}/api/users/invitation/`,
    googleSignin: `${baseUrl}/api/auth/google/`,
    importFileSheet: `${baseUrl}/api/presentation/import-sheet/`,
    stopVideoCall: `${baseUrl}/api/webrtc/stop/`,
    getUploadedImages: `${baseUrl}/api/uploaded/images`,
    searchGiphySticker: `${baseUrl}/api/slide/search-giphy-stickers`,
  },
  workerApi: {
    exportPdf: `${workerUrl}/api/export/pdf/`,
    exportExcel: `${workerUrl}/api/export/excel/`,
    uploadFileDocument: `${workerUrl}/api/upload/file-document/`,
    uploadFileDocumentV2: `${workerUrl}/api/upload/file-document/v2/`,
    uploadFileAudio: `${workerUrl}/api/upload/file-audio/`,
  },
  EXIT_KEYS: ['Escape'],
  NEXT_SLIDE_KEYS: ['ArrowRight', 'Space', 'PageDown', 'Enter'],
  DISABLE_ON_FOCUS_SLIDE_KEYS: ['Space', 'Enter', 'ArrowRight', 'ArrowLeft'],
  LAST_SLIDE_KEYS: ['ArrowLeft', 'PageUp'],
  ENTER_FULL_SCREEN_KEYS: ['KeyF'],
  SLIDE_CONTROLS_TIMEOUT: 2000,
  PRO_TIPS: [
    'While presenting, press F to present in full screen mode.',
    'While presenting, use the settings menu to the left to find more features',
  ],
  US_PRESENTING_MODE: 'Presenting Mode',
  LABEL_USER_INTERACTION: 'User Interaction',
  stripePublicKey,
  singaporeStripePublishableKey,
  MAX_NUMBER_OF_SLIDE,
  MAX_FOLDER_DEPTH,
  MAX_PRESENTATION_IN_FOLDER,
  configFile,
  ga4Id,
}
